import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LogoutFunction from "../services/LogoutFunction";
import swal from "sweetalert";

export const updateCourseApi = createAsyncThunk(
  "updateCourseData",
  async (courseNewData) => {
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;

    const request = await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/users/courses/update`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        },
        body: courseNewData,
      }
    )
      .then((respons) => respons.json())
      .then((resulet) => {
        console.log(resulet);
        return resulet;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    return request;
  }
);
function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}

const updateCourseDataSlicer = createSlice({
  name: "coures/update",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(updateCourseApi.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(updateCourseApi.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "jwt expired") {
        state.error = action.payload.message;
        formatError(state.error);
        LogoutFunction();
      }
      if (action.payload.message === " User updated Successfully") {
        state.data = action.payload;
        state.error = null;
      } else {
        state.data = null;
        state.error = action.payload.message;
      }
    });

    builder.addCase(updateCourseApi.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.payload.message;
    });
  },
});

export default updateCourseDataSlicer.reducer;
